import { useState, useEffect } from 'react';

import api from '../../services/api';
import FormatCurrency from '../../utils/FormatCurrency';
import Button from '../../components/Button';
import DesignerPaymentItem from '../../components/DesignerPaymentItem';
import Notification from '../../components/Notification';
import ModalWithInput from '../../components/ModalWithInput';
import ConfirmModal from '../../components/ConfirmModal';

import { Container, Header, BalanceContainer, Headline } from './styles';

const DesignerWallet = () => {
  const [wallet, setWallet] = useState({});
  const [isLoading, setLoading] = useState(true);
  const [isWithdrawMoneyOpen, setWithdrawMoneyOpen] = useState(false);
  const [isConfirmBankDataOpen, setConfirmBankDataOpen] = useState(false);
  const [bankInfo, setBankInfo] = useState(null);

  async function fetchWallet() {
    try {
      setLoading(true);
      const balancePromise = api.get('/designer_balance');
      const bankInfoPromise = api.get('/user');
      const [balanceResponse, bankInfoResponse] = await Promise.all([
        balancePromise,
        bankInfoPromise,
      ]);
      setWallet({
        balance: FormatCurrency(balanceResponse.data.balance),
        payments: balanceResponse.data.payments.map(t => ({
          ...t,
          amount: FormatCurrency(t.amount),
        })),
        blockedAmount: balanceResponse.data.blockedAmount,
      });
      setBankInfo(bankInfoResponse.data);
    } catch (err) {
      Notification({
        type: Notification.types.ERROR,
        message: 'Erro ao buscar dados da carteira',
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchWallet();
  }, []);

  function handleWithdrawMoneyButtonClick() {
    if (
      !bankInfo ||
      !bankInfo.bankCode ||
      !bankInfo.accountType ||
      !bankInfo.agency ||
      !bankInfo.account ||
      !bankInfo.recipientName
    ) {
      Notification({
        message: 'Preencha os dados bancários para realizar o saque',
        type: Notification.types.ERROR,
      });
      return;
    }

    setConfirmBankDataOpen(true);
  }

  function handleWithdrawMoneyModalClose() {
    setWithdrawMoneyOpen(false);
  }

  async function handleWithdrawMoneyModalConfirm(amount) {
    setWithdrawMoneyOpen(false);
    try {
      setLoading(true);
      await api.post('/withdrawal_money', { amount });
      fetchWallet();
      Notification({
        message: 'Sucesso ao realizar pedido de retirada',
        type: Notification.types.SUCCESS,
      });
    } catch (err) {
      const message = err.response.data
        ? err.response.data.error
        : 'Erro ao fazer pedido de retirada';

      Notification({
        message,
        type: Notification.types.ERROR,
      });
    } finally {
      setLoading(false);
    }
  }

  return isLoading ? (
    <div className="loader" />
  ) : (
    <>
      <ModalWithInput
        isOpen={isWithdrawMoneyOpen}
        onClose={handleWithdrawMoneyModalClose}
        onConfirm={handleWithdrawMoneyModalConfirm}
        text="Digite o valor que você desejar sacar de sua conta"
        title="Pedido de saque"
        inputType="number"
      />
      <ConfirmModal
        isOpen={isConfirmBankDataOpen}
        onClose={() => setConfirmBankDataOpen(false)}
        title="Confirmação de dados bancários"
        html={`<div><p>Você precisa confirmar seus dados bancários para prosseguir com o pedido de saque:</p><br/><p>Código do banco: <strong>${bankInfo?.bankCode}</strong></p><p>Tipo de conta: <strong>${bankInfo?.accountType}</strong></p><p>Agência: <strong>${bankInfo?.agency}</strong></p><p>Conta: <strong>${bankInfo?.account}</strong></p><p>Nome do destinatário: <strong>${bankInfo?.recipientName}</strong></p></div>`}
        confirmText="Confirmar"
        onConfirm={() => {
          setConfirmBankDataOpen(false);
          setWithdrawMoneyOpen(true);
        }}
      />
      <Container>
        <Header>
          <BalanceContainer>
            <small>Você tem</small>
            <h1>{wallet.balance}</h1>
            <small>*Você possui R${wallet.blockedAmount} bloqueados</small>
          </BalanceContainer>

          <Button
            text="Sacar dinheiro"
            primary
            onClick={handleWithdrawMoneyButtonClick}
          />
        </Header>
        {wallet.payments && wallet.payments.length > 0 && (
          <>
            <Headline>Vendas</Headline>
            <div>
              {wallet.payments.map(t => (
                <DesignerPaymentItem key={t.id} transaction={t} />
              ))}
            </div>
          </>
        )}
      </Container>
    </>
  );
};

export default DesignerWallet;
